import { Link } from "react-router-dom";
import { common_utils } from "../../../../../../../common/common_utils";
import {
	getRawProductWithoutPrices,
	PaymentInterval,
	PaymentIntervalToActiveName,
} from "../../../../../../../common/premium_tiers";
import { RouterInferenceHelpers } from "../../../../../../../src/api/trpc/rootRouter";
import { GenericEntitlement } from "./generic_entitlement";

export function StripeEntitlement(
	props: RouterInferenceHelpers["premium"]["getUserPremiumDetails"]["output"]["stripe_entitlements"][number]
) {
	const product = getRawProductWithoutPrices(props.product_id);

	return (
		<GenericEntitlement
			title={product.title}
			type={"Stripe"}
			modify_link={
				props.payment_interval !== PaymentInterval.OneTime ? (
					<Link
						className="secondary-link"
						to={common_utils.getStripeRedirectURL({
							type: "manager",
						})}
					>
						Modify
					</Link>
				) : undefined
			}
			payment_interval={PaymentIntervalToActiveName[
				props.payment_interval
			].toLowerCase()}
			details={
				<>
					<div>
						Activations Granted:{" "}
						<span className="font-bold">{props.activations}</span>
					</div>
					<div>
						Status:{" "}
						<span className="font-bold">{props.active_status}</span>
					</div>
					{props.is_from_admin && (
						<div>
							From admin: <span className="font-bold">true</span>
						</div>
					)}
				</>
			}
		/>
	);
}

export function StripeEntitlementNoModifyButton(
	props: RouterInferenceHelpers["premium"]["getUserPremiumDetails"]["output"]["stripe_entitlements"][number]
) {
	const product = getRawProductWithoutPrices(props.product_id);

	return (
		<GenericEntitlement
			title={product.title}
			type={"Stripe"}
			payment_interval={PaymentIntervalToActiveName[
				props.payment_interval
			].toLowerCase()}
			details={
				<>
					<div>
						Activations Granted:{" "}
						<span className="font-bold">{props.activations}</span>
					</div>
					<div>
						Status:{" "}
						<span className="font-bold">{props.active_status}</span>
					</div>
					{props.is_from_admin && (
						<div>
							From admin: <span className="font-bold">true</span>
						</div>
					)}
				</>
			}
		/>
	);
}
